<template>
  <div>
    <component :is="view"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Details from '@/views/BusinessScopeDetails.vue';
import Search from '@/views/BusinessScopeSearch.vue';

export default {
  name: 'app-client-redirect',
  computed: {
    ...mapState([
      'Search',
    ]),
    view() {
      return this.Search.length > 1 ? Search : Details;
    },
  },
};
</script>
